import {LoadingSpinner, Background } from "../styles/styles";
export const Loading = () => (
    <Background>
        <LoadingSpinner/>
    </Background>
    

);
  